(() => {
  // Aparición suave de secciones al entrar en pantalla
  const reveals = document.querySelectorAll('.reveal, [data-draw]');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('is-in'));
  }

  const fineHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Tarjetas: brillo que sigue al cursor (solo con mouse)
  if (fineHover) {
    document.addEventListener('pointermove', (e) => {
      const card = e.target.closest('[data-spotlight]');
      if (!card) return;
      const r = card.getBoundingClientRect();
      card.style.setProperty('--mx', `${e.clientX - r.left}px`);
      card.style.setProperty('--my', `${e.clientY - r.top}px`);
    }, { passive: true });
  }

  // Banner: las fotos se mueven suavemente con el cursor (profundidad)
  document.querySelectorAll('[data-parallax]').forEach((area) => {
    if (!fineHover || calm) return;
    const layers = [...area.querySelectorAll('[data-depth]')];
    const hero = area.closest('.hero') || area;
    let tx = 0, ty = 0, x = 0, y = 0, raf = 0;
    const tick = () => {
      x += (tx - x) * 0.08;
      y += (ty - y) * 0.08;
      layers.forEach((el) => {
        const d = Number(el.dataset.depth);
        el.style.translate = `${(x * d).toFixed(2)}px ${(y * d).toFixed(2)}px`;
      });
      raf = Math.abs(tx - x) + Math.abs(ty - y) > 0.001 ? requestAnimationFrame(tick) : 0;
    };
    const kick = () => { if (!raf) raf = requestAnimationFrame(tick); };
    hero.addEventListener('pointermove', (e) => {
      const r = hero.getBoundingClientRect();
      tx = (e.clientX - r.left) / r.width - 0.5;
      ty = (e.clientY - r.top) / r.height - 0.5;
      kick();
    }, { passive: true });
    hero.addEventListener('pointerleave', () => { tx = 0; ty = 0; kick(); });
  });

  // Secciones de scroll fijado: publican su avance (0 → 1) en --p
  const scrubbers = [...document.querySelectorAll('[data-scroll-progress]')];
  if (scrubbers.length && !calm) {
    document.documentElement.classList.add('has-scrub');
    let ticking = false;
    const measure = () => {
      ticking = false;
      const vh = window.innerHeight;
      scrubbers.forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.bottom < -vh || r.top > vh * 2) return;
        const p = Math.min(1, Math.max(0, -r.top / Math.max(1, r.height - vh)));
        el.style.setProperty('--p', p.toFixed(4));
        if (el.hasAttribute('data-rail')) {
          const track = el.querySelector('[data-rail-track]');
          const dist = Math.max(0, track.scrollWidth - track.clientWidth);
          track.style.transform = `translate3d(${(-dist * p).toFixed(1)}px, 0, 0)`;
          const idx = el.querySelector('[data-rail-index]');
          if (idx) idx.textContent = String(Math.min(track.children.length, Math.round(p * (track.children.length - 1)) + 1)).padStart(2, '0');
        }
      });
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(measure); } };
    // La altura del riel depende del ancho de los paneles
    const sizeRails = () => {
      scrubbers.filter((el) => el.hasAttribute('data-rail')).forEach((el) => {
        const track = el.querySelector('[data-rail-track]');
        const dist = Math.max(0, track.scrollWidth - track.clientWidth);
        el.style.height = `${window.innerHeight + dist}px`;
      });
      measure();
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', sizeRails);
    window.addEventListener('load', sizeRails);
    sizeRails();
  }

  // Carrito: cambiar cantidad o eliminar sin recargar la página
  const setCartCount = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  };

  async function changeLine(section, row, quantity) {
    if (section.dataset.busy) return;
    section.dataset.busy = '1';
    section.setAttribute('aria-busy', 'true');
    if (quantity === 0) row.classList.add('is-leaving');
    try {
      const root = window.Shopify?.routes?.root || '/';
      const res = await fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(row.dataset.cartLine), quantity }),
      });
      const cart = await res.json();
      if (!res.ok) throw new Error(cart.description || 'No se pudo actualizar el carrito');
      setCartCount(cart.item_count);
      const html = await (await fetch(`${root}cart?section_id=${section.dataset.cartSection}`)).text();
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-section]');
      if (quantity === 0) await new Promise((r) => setTimeout(r, 200));
      if (fresh) section.innerHTML = fresh.innerHTML;
      else location.reload();
    } catch (err) {
      row.classList.remove('is-leaving');
      toast(err.message);
    } finally {
      delete section.dataset.busy;
      section.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-cart-qty], [data-cart-remove]');
    const section = btn?.closest('[data-cart-section]');
    if (!section) return;
    e.preventDefault();
    const row = btn.closest('[data-cart-line]');
    const qty = btn.matches('[data-cart-remove]') ? 0 : Math.max(0, Number(btn.dataset.cartQty));
    changeLine(section, row, qty);
  });

  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-input]');
    const section = input?.closest('[data-cart-section]');
    if (!section) return;
    changeLine(section, input.closest('[data-cart-line]'), Math.max(0, Number(input.value) || 0));
  });

  // Carrusel de productos: flechas, arrastre nativo y avance automático suave
  document.querySelectorAll('[data-carousel]').forEach((root) => {
    const track = root.querySelector('[data-carousel-track]');
    const prev = root.querySelector('[data-carousel-prev]');
    const next = root.querySelector('[data-carousel-next]');
    if (!track) return;
    const step = () => {
      const card = track.firstElementChild;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return card ? card.getBoundingClientRect().width + gap : track.clientWidth;
    };
    const atEnd = () => track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    const bar = root.querySelector('[data-carousel-bar]');
    const sync = () => {
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = atEnd();
      if (bar) {
        const max = Math.max(1, track.scrollWidth - track.clientWidth);
        const shown = track.clientWidth / track.scrollWidth;
        bar.style.setProperty('--p', (shown + (1 - shown) * (track.scrollLeft / max)).toFixed(3));
      }
    };
    prev?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();

    const delay = Number(root.dataset.autoplay) * 1000;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!delay || reduce) return;
    let paused = false;
    let visible = false;
    ['pointerenter', 'focusin', 'touchstart'].forEach((ev) => root.addEventListener(ev, () => (paused = true), { passive: true }));
    ['pointerleave', 'focusout'].forEach((ev) => root.addEventListener(ev, () => (paused = false)));
    new IntersectionObserver(([en]) => (visible = en.isIntersecting)).observe(root);
    setInterval(() => {
      if (paused || !visible || document.hidden) return;
      if (atEnd()) track.scrollTo({ left: 0, behavior: 'smooth' });
      else track.scrollBy({ left: step(), behavior: 'smooth' });
    }, delay);
  });

  // Usa el formato de moneda de la tienda (p. ej. "S/ {{amount}}")
  const shopFormat = document.documentElement.dataset.moneyFormat || 'S/ {{amount}}';
  const moneyFormat = (cents) => {
    const n = cents / 100;
    return shopFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (_, kind) => {
      if (kind === 'amount_no_decimals') return Math.round(n).toLocaleString('en-US');
      if (kind.includes('comma')) return n.toLocaleString('de-DE', { minimumFractionDigits: 2 });
      return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    });
  };

  // Menú móvil
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-menu-toggle]');
    if (!toggle) return;
    const nav = document.getElementById(toggle.getAttribute('aria-controls'));
    const open = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', String(open));
  });

  // Barra de envío gratis: se actualiza al agregar productos sin recargar
  function updateShipBars(total) {
    document.querySelectorAll('[data-ship-bar]').forEach((bar) => {
      const goal = Number(bar.dataset.goal);
      const falta = goal - total;
      bar.classList.toggle('is-done', falta <= 0);
      bar.querySelector('.ship-bar__track span').style.setProperty('--fill', Math.min(1, total / goal).toFixed(3));
      bar.querySelector('[data-ship-text]').innerHTML = falta > 0
        ? `Te faltan <strong>${moneyFormat(falta)}</strong> para tu <strong>envío gratis</strong> (Lima y Callao; provincias pagando con Yape o Plin)`
        : '<strong>¡Tu envío es gratis</strong> en Lima y Callao!<br><small>Y en provincias gratis pagando con Yape o Plin.</small>';
    });
  }

  // Carrito: el botón de pago elegido queda como atributo "Método de pago preferido" y el formulario va al checkout.
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-pay]');
    const input = btn?.form?.querySelector('[data-pay-method]');
    if (input) input.value = btn.dataset.pay;
  });

  function toast(msg) {
    let el = document.querySelector('.toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(() => el.classList.remove('is-visible'), 2600);
  }

  // Página de producto
  document.querySelectorAll('[data-product]').forEach((root) => {
    const variants = JSON.parse(root.querySelector('[data-variants]').textContent);
    const form = root.querySelector('[data-product-form]');
    const idInput = root.querySelector('[data-variant-id]');
    const priceEl = root.querySelector('[data-price]');
    const addBtn = root.querySelector('[data-add-to-cart]');
    const waLink = root.querySelector('[data-wa-link]');
    const mainImg = root.querySelector('.js-gallery-main');
    const thumbs = [...root.querySelectorAll('[data-thumb]')];
    const unitEl = priceEl?.querySelector('.price__unit');

    const showImage = (btn) => {
      if (!btn || !mainImg) return;
      mainImg.removeAttribute('srcset');
      mainImg.src = btn.dataset.thumb;
      thumbs.forEach((t) => t.setAttribute('aria-current', String(t === btn)));
    };
    thumbs.forEach((btn) => btn.addEventListener('click', () => showImage(btn)));

    const selected = () => {
      const opts = [];
      form.querySelectorAll('[data-option]').forEach((input) => {
        if (input.checked) opts[Number(input.dataset.option)] = input.value;
      });
      return opts;
    };

    const update = () => {
      const opts = selected();
      const variant = variants.find((v) => v.options.every((o, i) => o === opts[i]));
      opts.forEach((v, i) => {
        const label = root.querySelector(`[data-option-label="${i}"]`);
        if (label) label.textContent = v;
      });
      // Marca como no disponibles las combinaciones agotadas
      form.querySelectorAll('[data-option]').forEach((input) => {
        const i = Number(input.dataset.option);
        const test = [...opts];
        test[i] = input.value;
        const match = variants.find((v) => v.options.every((o, j) => o === test[j]));
        input.classList.toggle('is-unavailable', !match || !match.available);
      });

      if (!variant) {
        addBtn.disabled = true;
        addBtn.textContent = 'No disponible';
        return;
      }
      idInput.value = variant.id;
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? 'Agregar al carrito' : 'Agotado';
      if (priceEl) {
        priceEl.innerHTML =
          moneyFormat(variant.price) +
          (variant.compare_at_price > variant.price ? ` <s>${moneyFormat(variant.compare_at_price)}</s>` : '') +
          (unitEl ? ' ' + unitEl.outerHTML : '');
      }
      if (waLink) {
        const msg = `${waLink.dataset.waBase} (${variant.title}) – ${waLink.dataset.waUrl}?variant=${variant.id}`;
        const url = new URL(waLink.href);
        url.searchParams.set('text', msg);
        waLink.href = url.toString();
      }
      if (variant.featured_media) {
        showImage(thumbs.find((t) => t.dataset.mediaId === String(variant.featured_media.id)));
      }
      const u = new URL(location.href);
      u.searchParams.set('variant', variant.id);
      history.replaceState(null, '', u);
    };

    form.addEventListener('change', (e) => e.target.matches('[data-option]') && update());
    update();

    form.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-qty]');
      if (!btn) return;
      const input = form.querySelector('input[name="quantity"]');
      input.value = Math.max(1, Number(input.value || 1) + Number(btn.dataset.qty));
    });

    // Agregar al carrito sin recargar (con respaldo al envío normal)
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      addBtn.disabled = true;
      try {
        const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || 'No se pudo agregar');
        const cart = await (await fetch('/cart.js')).json();
        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        updateShipBars(cart.total_price);
        toast('✓ Agregado al carrito');
      } catch (err) {
        toast(err.message);
      } finally {
        addBtn.disabled = false;
      }
    });
  });
})();
